import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { SuiDropdown, SuiDropdownOption } from '@splashthat/sui';

import { getFormNode } from 'common/entities/formNode/selectors';
import { getQuestionTypeOptions } from 'common/compounds/FormBuilder/selectors';
import { updateFormNodeValue } from '../../../actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

const INPUT_TYPE_LABEL = 'Question Type';

/**
 * The view to edit data type for a question.
 */
const InputTypeControl = ({ inputType, onChange, disabled, inputTypeOptions }) => (
    <SuiDropdown
        fullWidth
        label={INPUT_TYPE_LABEL}
        value={inputType}
        onChange={(event, value) => onChange(value)}
        disabled={disabled}
    >
        {inputTypeOptions.map((inputTypeOption) => (
            <SuiDropdownOption
                key={inputTypeOption.value}
                value={inputTypeOption.value}
                displayValue={inputTypeOption.displayValue}
            />
        ))}
    </SuiDropdown>
);

InputTypeControl.propTypes = {
    inputType: PropTypes.string,
    inputTypeOptions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            displayValue: PropTypes.string,
        }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};
InputTypeControl.defaultProps = {
    inputType: '',
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    const inputTypeOptions = getQuestionTypeOptions(state, get(formNode, 'name'));
    return {
        inputType: props.formNodeId ? formNode.inputType : '',
        inputTypeOptions,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (inputType) => dispatch(updateFormNodeValue(ownProps.formNodeId, 'inputType', inputType)),
});

const ConnectedInputTypeControl = connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(InputTypeControl));

ConnectedInputTypeControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedInputTypeControl.defaultProps = {
    formNodeId: undefined,
};

export const InputTypeControlDisableable = connect(mapStateToProps, mapDispatchToProps)(InputTypeControl);

export default ConnectedInputTypeControl;
